import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/youcam-4-google"
    path="business/services/youcam-4-google"
    element={<AsyncPage />}
  />,
];
